module.exports = __webpack_public_path__ + "img/77.78ae4440.jpg";